export const ElementsMapInformation = {
  venue: "ELEMENTS",
  venueId: "elements",
  i18nVenue: "elements",
  venueName: "Elements",
  floorAlignment: [
    {
      id: "5af5c7ac-0c7d-4806-8678-0ce75585d407",
      ordinal: -1,
      name: "L1",
      imageUrl:
        "https://locaite-dev.collectiv.co/assets/f155726c-827b-48a4-88b8-c6c2f3b5fac7/m5-1752094606911PATOZU.png",
      pixInMeter: 6.0225752732853985,
      center: { lat: 22.278455726183378, lng: 114.16627234226878 },
      angle: 311.7177605430511,
      scale: 166.04266070245396,
      corners: {
        tl: { lat: 22.278239006573557, lng: 114.16218947681222 },
        tr: { lat: 22.282233815270082, lng: 114.16603818232328 },
        br: { lat: 22.278672344063242, lng: 114.17035520772535 },
        bl: { lat: 22.274677637096673, lng: 114.16650647691166 },
      },
      size: { width: 3584, height: 3584 },
      sizeInMeters: { width: 595.0942638394572, height: 595.0942638811335 },
    },
  ],
  name: "",
  imageUrl: "",
  pixInMeter: 0,
  center: { lat: 0, lng: 0 },
  angle: 0,
  scale: 1,
  corners: {
    tl: { lat: 0, lng: 0 },
    tr: { lat: 0, lng: 0 },
    br: { lat: 0, lng: 0 },
    bl: { lat: 0, lng: 0 },
  },
  size: { width: 1, height: 1 },
  sizeInMeters: { width: 1, height: 1 },
  entry_mapId: 0,
  modelConfig: {
    folderPath: "venue/elements/",
    defaultPosition: [0, 21, 0],
    defaultTarget: [0, 21, 3],
    defaultFloorIndex: 0,
    defaultLcMapId: "L0",
    topAltitude: 300,
    downSpeed: 200,
    scaleFactor: 20,
    moveSpeed: 2,
    rotateSpeed: 20,
    splat: {
      mode: "singleLod",
      singleLod: "lod/lod-meta.json",
    },
    floor: [
      {
        lcMapId: "L0",
        index: 0,
        name: "L0",
        shortName: "L0",
        sog: "l0/elements_l0_20260106_2100.sog",
        altitude: 21,
        defaultPosition: [0, 21, 0],
        defaultTarget: [0, 21, 3],
      },
      {
        lcMapId: "L1",
        index: 1,
        name: "L1",
        shortName: "L1",
        sog: "l1/elements_l1_20260106_2100.sog",
        altitude: 90,
        defaultPosition: [130, 90, 0],
        defaultTarget: [130, 90, 3],
      },
    ],
  },
};
